'use strict';
import { htmlSearch } from "../functions.js";

document.addEventListener('DOMContentLoaded', () => {
  const popupSearch = document.querySelector('.popup-search');
  const searchBtnOpen = document.querySelector('.header__search-btn');
  const searchInput = document.querySelector('.popup-search__input');
  const searchClose = document.querySelector('.popup-search__close');
  const searchRecommended = document.querySelector('.popup-search__recommended');
  const searchNoResult = document.querySelector('.popup-search__no-result');
  const searchResult = document.querySelector('.popup-search__result');
  const searchForm = document.querySelector('.popup-search__form');

  searchBtnOpen.addEventListener('click', () => {
    popupSearch.classList.add('popup-search--active');
    document.body.classList.add('no-scroll');
  });

  window.addEventListener('keydown', (e) => {
    if(e.code === 'Escape' && popupSearch.closest('.popup-search--active')) {
      popupSearch.classList.remove('popup-search--active');
      document.body.classList.remove('no-scroll');
    }
  });

  popupSearch.addEventListener('click', (e) => {
    if(e.target === popupSearch) {
      popupSearch.classList.remove('popup-search--active');
      document.body.classList.remove('no-scroll');
    }
  });

  let timer;
  searchInput.addEventListener('input', (e) => {
    clearTimeout(timer);
    if(e.target.value === '') {
      searchNoResult.removeAttribute('style');
      searchResult.removeAttribute('style');
      searchRecommended.removeAttribute('style');
      return false;
    }

    timer = setTimeout(() => {
      let formData = new FormData();
      formData.append('action', 'search');
      formData.append('search', e.target.value);

      fetch(themeVar.url, {
        method: 'POST',
        body: formData,
      })
      .then(response => response.json())
      .then(data => {
        if(data.status == 'fail') {
          searchNoResult.style.display = 'block';
          searchResult.removeAttribute('style');
          searchRecommended.removeAttribute('style');
          return false;
        }

        const containerAppend = document.querySelector('#js-append-search .slider-container');
        htmlSearch(data.news, containerAppend);

        searchNoResult.removeAttribute('style');
        searchResult.style.display = 'block';
        searchRecommended.style.display = 'none';
      });
    }, 700);
  })

  searchClose.addEventListener('click', () => {
    popupSearch.classList.remove('popup-search--active');
    document.body.classList.remove('no-scroll');
  });

  searchForm.addEventListener('submit', (e) => e.preventDefault());

});